import { render } from "./Account.vue?vue&type=template&id=2cb88028&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=2cb88028&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb88028"]])

export default __exports__